<div red-flow-item [attr.redBorder]="border" [attr.redMinHeight]="minheight"  [attr.redWidth]="width"  redColor="secondary" redShadow="secondary">
  <ng-content></ng-content>
</div>